import { SqlEditor } from '@shadcn/components/sql-editor';
import { UsersGrowthChart } from '@shadcn/components/users-growth-chart';

const DEFAULT_SORT_FIELD = 'created_at';
const DEFAULT_SORT_DIRECTION: 'ASC' | 'DESC' = 'DESC';
const DEFAULT_LIMIT = 100;
const DEFAULT_TIME_RANGE = 90;
const DEFAULT_SQL = `SELECT * FROM auth.users ORDER BY ${DEFAULT_SORT_FIELD} ${DEFAULT_SORT_DIRECTION} LIMIT ${DEFAULT_LIMIT};`;

export function UsersManager() {
  return (
    <div className="pt-12">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <h1 className="text-base lg:text-xl font-semibold">User Management</h1>
          <p className="hidden lg:block text-sm lg:text-base text-bolt-ds-textSecondary mt-2">
            Track new users creation on your app.
          </p>
        </div>
      </div>
      <div className="py-8">
        <UsersGrowthChart timeRange={DEFAULT_TIME_RANGE} />
      </div>
      <SqlEditor
        initialSql={DEFAULT_SQL}
        defaultSortField={DEFAULT_SORT_FIELD}
        defaultSortDirection={DEFAULT_SORT_DIRECTION}
        defaultLimit={DEFAULT_LIMIT}
        hideSql
        label={<span className="text-sm text-bolt-ds-textTertiary font-semibold">Recent users</span>}
        runAutomatically={true}
        noResultLabel="You don’t have any users yet."
        readOnly
        includedFields={[
          'id',
          'role',
          'last_sign_in_at',
          'email',
          'created_at',
          'updated_at',
          'is_sso_user',
          'is_anonymous',
        ]}
      />
    </div>
  );
}
